import React from "react";
import { injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import imgResultadoPetTratamiento from "../../assets/tests/scn4/resultado-pet-tratamiento-next.jpg";
import imgEstudiosDra from "../../assets/img-caso/scenario5-img2.png";
import NextButton from "../../components/NextButton";
import ScenarioBar from "../../components/ScenarioBar";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import { IconMicroscope, IconClipboardList } from "@tabler/icons-react";

function Scenario5Seguimiento2({ intl }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const activeScenario = getScenarioNumByPath(location.pathname);

  return (
    <div className="h-100">
      <div className="container-fluid">
        <div className="row h-100">
          <div
            className="col-md-12 d-flex flex-column justify-content-around px-5 mt-4"
          >
            <h5 className="mb-2">Estrategias de soporte y profilaxis:</h5>
            <div className="notaCasoClinicoAutor">caso clínico del autor</div>
            <div className="d-flex flex-column align-items-center">
              <img src={imgEstudiosDra} className="mt-2" style={{width: "100%"}}></img>
            </div>
            <div className="mt-4 d-flex align-items-center justify-content-end w-100">
              {/* Botón siguiente */}
              <NextButton
                navigateTo={ROUTES.SCENARIO5_APALUTAMIDA}
                activeScenario={activeScenario}
                color="green"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Barra inferior */}
      <ScenarioBar activeScenario={activeScenario} />
    </div>
  );
}

export default injectIntl(Scenario5Seguimiento2);
